module.exports = __webpack_public_path__ + "media/newstyle/images/cta-mobile_es-0fb4f3fb781182777cbad0fa3ba73169.jpg";